import { ModuleRouteMeta } from './module-registry';
import { NavItem } from './nav-item';
import { UserModule } from './user-module';
import { ModuleRegistry, userModulesToNavItems } from './user-modules-to-nav-items';

/**
 * Allowlist for the right-side `+ New` action menu in the header. Drives the
 * legacy "create" dropdown (Rates ▸ Ratecard / Ratesheet → Quote → Booking),
 * filtered by the same per-tenant module permissions as the main menubar.
 *
 * Kept separate from `MODULE_REGISTRY` so the create flow is independently
 * extensible and never leaks into the main navigation.
 *
 * Display order (lower weight first):
 *
 *   Rates (group, inherits 10)
 *     ├─ Ratecard      (addRate,         weight 10)
 *     └─ Ratesheet     (uploadRateSheet, weight 11)
 *   Quote               (createQuote,     weight 20)
 *   Booking             (createShipment,  weight 30)
 */
export const CREATE_MENU_REGISTRY: Readonly<Record<string, ModuleRouteMeta>> = {
  addRate: {
    route: '/create/rate',
    icon: 'pi pi-dollar',
    parent: 'Rates',
    weight: 10,
    label: 'Ratecard',
  },
  uploadRateSheet: {
    route: '/create/rate-sheet',
    icon: 'pi pi-upload',
    parent: 'Rates',
    weight: 11,
    label: 'Ratesheet',
  },
  createQuote: {
    route: '/create/quote',
    icon: 'pi pi-file',
    parent: '',
    weight: 20,
    label: 'Quote',
  },
  createShipment: {
    route: '/create/shipment',
    icon: 'pi pi-send',
    parent: '',
    weight: 30,
    label: 'Booking',
  },
};

/**
 * Thin convenience wrapper around `userModulesToNavItems` pre-bound to the
 * create-menu registry. Returns the `+ New` button's nested `NavItem` tree
 * for the current tenant; empty when none of the create modules are
 * permissioned.
 */
export function userModulesToCreateNavItems(modules: readonly UserModule[]): NavItem[] {
  return userModulesToNavItems(modules, CREATE_MENU_REGISTRY as ModuleRegistry);
}
